<template>
  <v-autocomplete
    v-model="storeGroup"
    :items="userStoreParties"
    background-color="input"
    class="mt-7 ma-0"
    dense
    item-text="party_name"
    item-id="party_id"
    label="Store Group / Store"
    :menu-props="{ maxHeight: 300 }"
    outlined
    return-object
    @change="updateStoreGroup">
  </v-autocomplete>
</template>

<script>
import Parties from '@/axios/parties'
import { userAccess } from "@/mixins/user-access"
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'StoreGroupsDropdown',
  props: {
    value: Object
  },
  mixins: [userAccess, displayAlert],
  data() {
    return {
      storeGroup: {},
      userStoreParties: []
    }
  },
  computed: {},
  async created() {
    await this.getUserStoreGroups()
    this.storeGroup = sessionStorage.tpr_pro_store_group ? JSON.parse(sessionStorage.tpr_pro_store_group) : this.userStoreParties.find(p => p.party_id)
    this.$emit('updateStoreGroup', this.storeGroup)
  },
  methods: {
    async getUserStoreGroups() {
      try {
        const { data } = await Parties.getUserProfileTprStoreGroups(this.userId)
        const storeGroups = [{header: 'Store Groups'}, ...data.filter(p => p.party_type === 'TPR_STORE_GROUP').sort((a, b) => {return a.party_name.localeCompare(b.party_name)})]
        const stores = [{header: 'Stores'}, ...data.filter(p => p.party_type === 'STORE').sort((a, b) => {return a.party_name.localeCompare(b.party_name)})]
        this.userStoreParties = [...storeGroups, ...stores]
      } catch (err) {
        this.handleError(err)
      }
    },
    updateStoreGroup() {
      sessionStorage.setItem('tpr_pro_store_group', JSON.stringify(this.storeGroup))
      this.$emit('updateStoreGroup', this.storeGroup)
    }
  }
}
</script>
<style>
div.v-subheader.theme--light {
  font-weight: bold !important;
  color: black !important;
  font-size: medium !important;
}
</style>